import { createAsyncActions } from "~/utils/store";

export var LOAD_EXTRATO = createAsyncActions("LOAD_EXTRATO");

export var loadExtrato = function(params) {
    return {
        type: LOAD_EXTRATO.INIT,
        payload: {
            request: {
                method: "GET",
                url: "/extrato",
                params: params,
            },
            filter: params,
        },
    };
};
